import React from "react";
import { Product } from "@/types/types";
import { TickOutlined } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/TickOutlined";
import { Drawer } from "@JohnLewisPartnership/jl-design-system/dist/components/drawer/Drawer";
import { dispatchMonetateQEvent } from "@/utils/monetate/monetateQ";
import { CompetitorList } from "./CompetitorList";
import styles from "./PricePromiseUIV2.module.scss";

interface PricePromiseDrawerProps {
  product: Product;
  isOpen: boolean;
  onClose: () => void;
  isJohnLewisProduct?: boolean;
}

const TICK_SIZE = "large";

export const PricePromiseDrawer: React.FC<PricePromiseDrawerProps> = ({
  product,
  isOpen,
  onClose,
  isJohnLewisProduct = false,
}) => {
  function handlePricePromiseURLClick(
    e: React.MouseEvent<HTMLAnchorElement>,
  ): void {
    e.preventDefault();
    dispatchMonetateQEvent("pdp:price-promise:url-displayed");
    const hrefTarget = e.currentTarget.getAttribute("href") || "";
    window.location.href = hrefTarget;
  }

  return (
    <Drawer
      heading=""
      isOpen={isOpen}
      onClose={onClose}
      className={styles.drawer}
    >
      <h2 className={styles.drawerTitle}>Our price promise</h2>
      <div className={styles.drawerBody}>
        {isJohnLewisProduct ? (
          <>
            <h3 className={styles.subHeading}>We match our own prices too</h3>
            <ul className={styles.tickList}>
              <li>
                <TickOutlined size={TICK_SIZE} /> If we drop the price up to 7
                days after you buy, you can request a refund for the difference.
              </li>
            </ul>
          </>
        ) : (
          <>
            <h3 className={styles.subHeading}>
              We&apos;re already price matching this item
            </h3>
            <ul className={styles.tickList}>
              <li>
                <TickOutlined size={TICK_SIZE} /> We automatically check our
                prices against 25 top retailers, and if we find a better price
                we&apos;ll match it
              </li>
              <li>
                <TickOutlined size={TICK_SIZE} /> If they drop the price up to 7
                days after you buy, you can request a refund for the difference.
                You can also do this if we drop the price ourselves.
              </li>
              <li>
                <TickOutlined size={TICK_SIZE} /> We even match promotions and
                seasonal offers, exclusions apply.
              </li>
            </ul>
          </>
        )}
        <a
          onClick={handlePricePromiseURLClick}
          className={styles.moreInfoLink}
          href="https://www.johnlewis.com/customer-services/prices-and-payment/price-promise?source=pricepromisedrawer"
        >
          {isJohnLewisProduct ? (
            "How to request a refund"
          ) : (
            <>How our price promise works</>
          )}
        </a>
        {!isJohnLewisProduct && <CompetitorList product={product} />}
      </div>
      <footer className={styles.drawerFooter}>Never knowingly undersold</footer>
    </Drawer>
  );
};
